import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Box,
  Input,
  Flex,
  Text,
  Stack,
  IconButton,
  Tooltip,
  useToast,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  Modal,
  ModalContent,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useMediaQuery,
} from "@chakra-ui/react";
import { RiDeleteBin6Line } from "react-icons/ri";
import { CgSmileMouthOpen } from "react-icons/cg";
import { MdOutlineAttachFile, MdFormatColorText } from "react-icons/md";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./EmailAllReply.css";
import EmojiPicker from "emoji-picker-react";
import { HiTemplate } from "react-icons/hi";
import { AiFillOpenAI } from "react-icons/ai";
import axios from "axios";
import { PulseLoader } from "react-spinners";

const AllEmailReply = ({
  isAllReplyOpen,
  setIsAllReplyOpen,
  message,
  isNonGeneral,
  currentEmail,
  isPencilClick,
  threadId,
  getAllMessagesAPI,
}) => {
  const [emailContent, setEmailContent] = useState("");
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [link, setLink] = useState("");
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [emailTemplateData, setEmaiTemplateData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [isEmailEmpty, setIsEmailEmpty] = useState("");
  const [ccMail, setccMail] = useState();
  const [bccMail, setbccMail] = useState();
  const toast = useToast();
  const quillRef = useRef(null);
  const popoverRef = useRef(null); 
  const token = localStorage.getItem("token");
  const userEmail = localStorage.getItem("userEmail");
  const BASE_URL = process.env.REACT_APP_DEPLOYED_BASE_URL;
  const [isClassActive, setIsClassActive] = useState(false);
  const [loading, setIsLoading] = useState(false);

  const [isMobile] = useMediaQuery("(max-width: 768px)");

  const filteredMessages = message?.filter(
    (msg) => msg.from_email !== userEmail
  );

  const latestMessage =
    filteredMessages.length > 0
      ? filteredMessages.reduce((latest, current) => {
          return new Date(current.created_at) > new Date(latest.created_at)
            ? current
            : latest;
        })
      : message[0];

  const recipientEmailMatch = latestMessage.from_email.match(/<([^>]+)>/);
  let email = recipientEmailMatch ? recipientEmailMatch[1] : latestMessage.to;

  if (email === userEmail) {
    email = latestMessage.to;
  } else {
    email = latestMessage.from_email;
    latestMessage.to.split(", ").forEach((singleEmail) => {
      const match = singleEmail.match(/<([^>]+)>/);

      if (match && match[1] !== userEmail) {
        email += `, ${singleEmail}`;
      }
    });
  }

  const fullEmail = !isNonGeneral ? message[0].from_email : currentEmail;
  useEffect(() => {

    
    setRecipientEmail(email.replace(/[^\x20-\x7E]/g, '').replace(/[<>]/g, '').trim());
  }, [latestMessage]);

  useEffect(() => {
    if (message && message.length > 0) {
      const latestMessage = message[message.length - 1]; // Get the latest message
      if (latestMessage.cc) {
        setccMail(latestMessage.cc.replace(/[^\x20-\x7E]/g, '').replace(/["]/g, '').trim());
      }
      if (latestMessage.bcc) {
        setbccMail(latestMessage.bcc.replace(/[^\x20-\x7E]/g, '').replace(/["]/g, '').trim());
      }
    }
  }, [message]);

  const handleEditorChange = (content) => {
    setEmailContent(content);

    // Real-time validation
    if (!content || !content.trim()) {
      setIsEmailEmpty("The email message cannot be empty.");
    } else {
      setIsEmailEmpty("");
    }
  };

  const formatEmailContent = (content) => {
    let formattedContent = content
      .replace(/<p>/g, "")
      .replace(/<\/p>/g, "<br/>");

    formattedContent = formattedContent.replace(/<br(?!\/)>/g, "");
    formattedContent = formattedContent.replace(
      /(<br\/>)(?=\s*<br\/>)/g,
      "<br/>"
    );
    formattedContent = formattedContent.trim();
    if (formattedContent.endsWith("<br/>")) {
      formattedContent = formattedContent.slice(0, -5);
    }
    return formattedContent;
  };

  const handleSendEmail = async () => { 
    const formattedContent = formatEmailContent(emailContent);
    if (!formattedContent || !formattedContent.trim()) {
      setIsEmailEmpty("The email message cannot be empty.");
      return;
    }

    let formattedEmail = recipientEmail.replace(/,/g, ' , ').replace(/[<>]/g, '').replace(/<([^>]+@[^>]+\.[a-zA-Z]{2,6})>/g, '<$1>');
    formattedEmail = formattedEmail.replace(/([\w\.-]+@[\w\.-]+\.[a-zA-Z]{2,6})(?=\s|$)/g, '<$1>').replace(/ , /g, ',');

    const formData = new FormData();
    formData.append("sender", userEmail);
    formData.append("to", formattedEmail);
    formData.append("cc", ccMail ?? "");
    formData.append("bcc", bccMail ?? "");
    formData.append("subject", latestMessage.subject);
    formData.append("message_text", formattedContent);
    formData.append("thread_id", message[0].thread_id);
    formData.append("reply_message_id", latestMessage.reply_message_id);
    formData.append("references", latestMessage.references);
    formData.append("in_reply_to", latestMessage.in_reply_to);
    formData.append("full_email", fullEmail);
    formData.append("full_email_to", message[0].from_email);

    if (file) {
      formData.append("file", file);
    }

    if (isEmailEmpty) {
      setIsEmailEmpty("The email message cannot be empty.");
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/send-reply/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      toast({
        title: "Email sent.",
        description: "Your email reply has been sent successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      getAllMessagesAPI(message[0].thread_id);
      setIsAllReplyOpen(false);
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Error sending email.",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleFileUpload = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
      setFileName(uploadedFile.name);
      toast({
        title: "File uploaded.",
        description: `${uploadedFile.name} has been added.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleAddEmoji = (emojiData) => {
    const emoji = emojiData.emoji;
    const quill = quillRef.current.getEditor();
    const cursorPosition = quill?.getSelection()?.index || 0; 
    
  
    quill.insertText(cursorPosition, emoji); 
    quill.setSelection(cursorPosition + emoji.length);
  };

  const modules = {
    toolbar: {
      container: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [
          {
            color: [
              "red",
              "blue",
              "yellow",
              "white",
              "orange",
              "green",
              "purple",
            ],
          },
          { background: [] },
        ],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
      ],
    },
  };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "list",
    "bullet",
    "link",
    "image",
  ];

  const fetchEmailTemp = async () => {
    try {
      // setIsCompanySearchLoading(true);
      //    /get-autorespond-template/
      const response = await fetch(`${BASE_URL}/get-composer-temp/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setEmaiTemplateData(data.data);

      if (data.code === "token_not_valid") {
        localStorage.removeItem("userEmail");
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
      // setFilteredCompanyData(data?.companies);
      // setIsCompanySearchLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchEmailTemp();
  }, []);

  const handleShowEmailsTemplates = () => {
    setOpenPopup(true);
  };

  const handleAutoRespond = async () => {
    setIsLoading(true);
    const object = {
      email_body: latestMessage?.snippet ? latestMessage?.snippet : "",
    };
    try {
      const result = await axios.post(`${BASE_URL}/ai-respond/`, object, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (result.status === 200) {
        setIsLoading(false);
        setEmailContent(result?.data?.message || "");
        //  onClose();
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleTemplateSelect = (templateName, templateBody) => {
    const updatedContent = templateBody.replace(
      /<strong>(.*?)<\/strong>/g,
      "$1"
    );
    setEmailContent(updatedContent);
    setOpenPopup(false);
  };

  const handleDoubleClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const ShowFormattingText = () => {
    const toolbar = document.querySelector(".quill-editor .ql-toolbar");
    if (window.innerWidth <= 768) {
      if (toolbar) {
        const currentDisplay = getComputedStyle(toolbar).display;
        if (currentDisplay === "none") {
          toolbar.style.display = "";
          setIsClassActive(true);
        } else {
          toolbar.style.display = "none";
          setIsClassActive(false);
        }
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const toolbar = document.querySelector(".quill-editor .ql-toolbar");
      if (toolbar) {
        // Check window width and toggle toolbar visibility
        if (window.innerWidth <= 768) {
          toolbar.style.display = "none"; // Hide toolbar for small screens
        } else {
          toolbar.style.display = ""; // Show toolbar for larger screens
        }
      }
    };

    // Attach resize event listener
    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
          setShowEmojiPicker(false); 
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

  return (
    <div className="allReply_modal-body">
      <Box
        maxW="1400px"
        height="100%"
        mx="auto"
        p={5}
        borderWidth="1px"
        borderRadius="lg"
        boxShadow="lg"
        backgroundColor="#ffffff"
        position="relative"
      >
        <Stack spacing={4}>
          <Flex align="center">
            <Text w="30px">To:</Text>
            <Input
              variant="flushed"
              value={recipientEmail.replace(/["]/g, '')}
              onDoubleClick={handleDoubleClick}
              onBlur={handleBlur}
              onChange={(e) => setRecipientEmail(e.target.value)}
            />
          </Flex>
          {isPencilClick && (
            <>
              <Flex className="all_email_reply_cc_input">
                <Text w="30px">cc:</Text>
                <Input
                  variant="flushed"
                  value={ccMail}
                  onDoubleClick={handleDoubleClick}
                  onBlur={handleBlur}
                  onChange={(e) => setccMail(e.target.value)}
                />
              </Flex>
              {bccMail && (
                <Flex className="all_email_reply_bcc_input">
                  <Text w="30px">bcc:</Text>
                  <Input
                    variant="flushed"
                    value={bccMail}
                    readOnly={!isEditing}
                    onDoubleClick={handleDoubleClick}
                    onBlur={handleBlur}
                    onChange={(e) => setbccMail(e.target.value)}
                  />
                </Flex>
              )}
            </>
          )}
          <Box as="div">
            <div className="custom-quill-container">
              <ReactQuill
                ref={quillRef}
                value={emailContent}
                onChange={handleEditorChange}
                theme="snow"
                modules={modules}
                formats={formats}
                className="quill-editor"
              />
            </div>
            {isEmailEmpty && (
              <span
                className="email_composer_error"
                style={{ color: "red", position: "absolute", bottom: "128px" }}
              >
                Email message is required!
              </span>
            )}
          </Box>
          <Box
            as="div"
            position="relative"
            className="add_formatting_text"
            height={isClassActive ? "130px" : isMobile ? "40px" : "95px"}
          >
            <Flex
              position="absolute"
              top="50px"
              width="100%"
              style={{
                position: "relative",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
              }}
              className={
                isClassActive
                  ? "reply_all_active-class"
                  : "reply_all_inactive-class"
              }
            >
              <Box display="flex" alignItems="center">
                <Button
                  colorScheme="blue"
                  size="lg"
                  borderRadius="8"
                  onClick={handleSendEmail}
                  height="40px"
                  width="100px"
                  fontSize="17px"
                >
                  Send
                </Button>
              </Box>

              <Tooltip label="Formatting Text" aria-label="Formatting Text">
                <IconButton
                  ml={0}
                  icon={<MdFormatColorText fontSize="24px" />}
                  aria-label="Formatting Text"
                  bg="transparent"
                  _hover={{ bg: "transparent" }}
                  onClick={ShowFormattingText}
                />
              </Tooltip>

              <input
                type="file"
                id="file-upload"
                style={{ display: "none" }}
                onChange={handleFileUpload}
              />
              <Tooltip label="Attach File" aria-label="Attach File">
                <label htmlFor="file-upload">
                  <IconButton
                    as="span"
                    ml={0}
                    icon={<MdOutlineAttachFile fontSize="24px" />}
                    aria-label="Attach File"
                    bg="transparent"
                    _hover={{ bg: "transparent" }}
                  />
                </label>
              </Tooltip>

              {fileName && (
                <Text ml={0} fontSize="sm" color="gray.500">
                  {fileName}
                </Text>
              )}

              <Popover
                isAllReplyOpen={showEmojiPicker}
                onClose={() => setShowEmojiPicker(false)}
                closeOnBlur={false}
              >
                <PopoverTrigger>
                  <IconButton
                    ml={0}
                    icon={<CgSmileMouthOpen fontSize="24px" />}
                    aria-label="Insert Emoji"
                    className="emoji-icon-container"
                    bg="transparent"
                    _hover={{ bg: "transparent" }}
                    onClick={() => setShowEmojiPicker((prev) => !prev)}
                  />
                </PopoverTrigger>
                <PopoverContent ref={popoverRef}>
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <Box p={2} className="emoji-icon-container">
                    <EmojiPicker width={302} height={350} className="emoji-container" onEmojiClick={handleAddEmoji} />
                  </Box>
                </PopoverContent>
                <Box>
                  <Tooltip label="Email-Template" aria-label="Email-Template">
                    <label htmlFor="Email-Template">
                      <IconButton
                        as="span"
                        icon={<HiTemplate fontSize="24px" />}
                        aria-label="Attach File"
                        bg="transparent"
                        _hover={{ bg: "transparent" }}
                        onClick={handleShowEmailsTemplates}
                      />
                    </label>
                  </Tooltip>
                </Box>
                <Box>
                  <Tooltip label="AI Reply" aria-label="auto-responde">
                    <label htmlFor="auto-responde">
                      {!loading ? (
                          <IconButton
                          as="span"
                          icon={<AiFillOpenAI fontSize="24px" />}
                          aria-label="auto-respond"
                          bg="transparent"
                          // className="hitemplate_icon"
                          _hover={{ bg: "transparent" }}
                          onClick={handleAutoRespond}
                        />
                        // <AiFillOpenAI
                        //   className="hitemplate_icon"
                        //   aria-label="auto-respond"
                        //   onClick={handleAutoRespond}
                        // />
                      ) : (
                        <IconButton
                          as="span"
                          icon={<PulseLoader fontSize="24px" />}
                          aria-label="auto-respond"
                          bg="transparent"
                          // className="hitemplate_icon"
                          _hover={{ bg: "transparent" }}
                          onClick={handleAutoRespond}
                        />
                        // <PulseLoader
                        //   className="hitemplate_icon"
                        //   size={8}
                        //   color="black"
                        // />
                      )}
                    </label>
                  </Tooltip>
                </Box>
              </Popover>
              <div className="email_composer_del_icon"> 
                <IconButton
                  as="span"
                  icon={<RiDeleteBin6Line fontSize="24px" />}
                  aria-label="Attach File"
                  bg="transparent"
                  _hover={{ bg: "transparent" }}
                  onClick={() => setIsAllReplyOpen(false)}
                />
              </div>
              {/* <RiDeleteBin6Line
                className="email_composer_del_icon"
                style={{
                  fontSize: "24px",
                  right: "25px",
                  position: "absolute",
                }}
                onClick={() => setIsAllReplyOpen(false)}
              /> */}
            </Flex>
          </Box>
        </Stack>
      </Box>
      {openPopup && (
        <Modal isOpen={isAllReplyOpen} onClose={() => setOpenPopup(false)}>
          <ModalOverlay />
          <ModalContent style={{ height: "500px", overflow: "auto" }}>
            <ModalHeader>Email Templates</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <div className="email-templates-list">
                {emailTemplateData.map((template) => (
                  <div
                    key={template.id}
                    className="template-item"
                    onClick={() =>
                      handleTemplateSelect(template.name, template.body)
                    }
                    style={{
                      cursor: "pointer",
                      margin: "8px 0",
                      padding: "10px",
                      border: "1px solid transparent",
                      borderRadius: "4px",
                      transition: "background-color 0.2s, border 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f0f0f0";
                      e.currentTarget.style.border = "1px solid #ccc";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.border = "1px solid transparent";
                    }}
                  >
                    <span>{template.name}</span>
                    <span style={{ marginLeft: "8px", color: "#888" }}>→</span>
                  </div>
                ))}
              </div>
            </ModalBody>

            {/* <ModalFooter>
              <Button colorScheme="blue" onClick={() => setOpenPopup(false)}>
                Close
              </Button>
            </ModalFooter> */}
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

export default AllEmailReply;
